import clsx from "clsx";

interface Props extends React.PropsWithChildren {
  collapsed?: boolean;
}
export const CardCollapsibleContent: React.FC<Props> = ({ collapsed, children }) => {
  return <div className={clsx("cpln-ant-card-collapsible-content", { collapsed })}>{children}</div>;
};
